export const newApplicationBankAccount = {
  id: 0,
  accountNumber: '',
  enableRemove: true,
  openingDate: null,
  assignedLicenses: []
}
